export default "__VITE_ASSET__DmVLo3mx__"